<template>
  <b-card
      title="مدیریت پیام های زمان دار"
  >
    <b-button
        class="mb-1 mr-auto ml-1"
        variant="primary"
        :to="{ name: 'scheduleDetails'}"
    >
      جدید
    </b-button>
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.MessageText"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="گروه چت"
                    label-for="MessageGroupId"
                >
                  <groupMessageSelector
                      v-model="filterOptions.MessageGroupId"
                      :multiple="false"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Schedule)="data">
            {{ data.value | date }}
          </template>
          <template #cell(Pinned)="data">
            <feather-icon v-if="data.value" class="mr-1 text-success" icon="CheckSquareIcon" size="20" />
            <feather-icon v-else  class="mr-1" icon="SquareIcon" size="20" />
          </template>
            <template #cell(Apply)="data">
            <feather-icon v-if="data.value" class="mr-1 text-success" icon="CheckSquareIcon"  size="20" />
            <feather-icon v-else  class="mr-1" icon="SquareIcon" size="20" />
          </template>

          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <b-link :to="{ name: 'scheduleDetails', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>
import groupMessageSelector from "@/tools/groupMessageSelector.vue";


export default {
  name: 'ScheduleMessage',
  components:{groupMessageSelector},
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        MessageText: null,
        Page: 1,
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD'),
        MessageGroupId: null
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'MessageText',
          label: 'پیام',
        },
        {
          key: 'GroupName',
          label: 'اسم گروه',
        },
        {
          key: 'Pinned',
          label: 'سنجاق',
        },
        {
          key: 'Schedule',
          label: 'زمان',
        },
        {
          key: 'StatusText',
          label: 'وضعیت',
        },
        {
          key: 'Apply',
          label: 'اعمال شده',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.get(
          this.$api.messenger.ScheduleMessageList, { params:this.filterOptions},
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.removeRow(this.$api.messenger.ScheduleMessageRemove, 'Id', id)
    },
  },
}
</script>
